// extracted by mini-css-extract-plugin
module.exports = {"content":"Faq_content__2MoK0"};